import DatePicker from 'vue2-datepicker';
export default {
    name: 'distributionTax',
    components: {
        DatePicker,
    },
    data() {
        return {
            loader: false,
            unsubscribe: null,
            docNumFrom: null,
            docNumTo: null,
            invoiceDateFrom: null,
            invoiceDateTo: null,
            amountFrom: null,
            amountTo: null,
            invoiceNum: null,
            distributionTaxData: [],
            distributionTaxFields: [
                {
                    key: 'select'
                },
                {
                    key: 'gstn',
                    label: 'GSTN'
                },
                {
                    key: 'gstn_vendor',
                    label: 'GSTN Vendor'
                },
                {
                    key: 'vendor_name'
                },
                {
                    key: 'invoice_number'
                },
                {
                    key: 'voucher_number'
                },
                {
                    key: 'invoice_date'
                },
                {
                    key: 'gl_date',
                    label: 'GL Date'
                },
                {
                    key: 'igst',
                    label: 'IGST'
                },
                {
                    key: 'cgst',
                    label: 'CGST'
                },
                {
                    key: 'sgst',
                    label: 'SGST'
                },
                {
                    key: 'cess',
                    label: 'CESS'
                },
                {
                    key: 'remark'
                }
            ]
        };
    },
    mounted() {},
    methods: {
        distributionTaxList() {

        },
    },
};